<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">고객센터</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 고객센터 페이지 -->
      <div class="p-customer-wrap">
        <div class="l-white-box">
          <!-- D: 상단 탭 : 자주 찾는 질문, 1:1문의, 공지사항 -->
          <div class="c-tabs">
            <ul>
              <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 0 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 0,
                    },
                  ]"
                  role="tab"
                  aria-selected
                >
                  자주 찾는 질문
                </a>
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 1 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 1,
                    },
                  ]"
                  role="tab"
                >
                  1:1문의
                </a>
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 2 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 2,
                    },
                  ]"
                  role="tab"
                >
                  공지사항
                </a>
              </li>
            </ul>
          </div>

          <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
          <!-- D: border가 없는경우 type-non-border 추가 -->
          <div class="c-tab-panel-wrap type-non-border">
            <!-- tab content: tab1 -->
            <div
              v-if="data.tab1Index == 0"
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-1"
              :hidden="data.tab1Index != 0"
            >
              <FaqListTab />
            </div>
            <!-- tab content: tab2 -->
            <div
              v-if="data.tab1Index == 1"
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-2"
              :hidden="data.tab1Index != 1"
            >
              <InquiryTab />
            </div>
            <!-- tab content: tab3 -->
            <div
              v-if="data.tab1Index == 2"
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-3"
              :hidden="data.tab1Index != 2"
            >
              <NoticeTab />
            </div>
          </div>

          <!-- 고객 지원 -->
          <div class="c-customer-footer">
            <div class="section">
              <strong class="subject">무엇을 도와드릴까요?</strong>
              <div class="tel-group">
                <p class="text">고객문의</p>
                <p class="tel">
                  <a href="tel:080-944-7777">080-944-7777</a>
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section">
              <div class="tel-group">
                <p class="text">담당 영업사원</p>
                <p class="tel">
                  <a :href="`tel:${data.page.zphoneNo}`"
                    >{{ data.page.zempName }} {{ data.page.zphoneNo }}</a
                  >
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section"></div>
          </div>

          <!-- //D: 상단 탭 : 자주 찾는 질문, 1:1문의, 공지사항 -->
        </div>
      </div>
    </div>
    <QuickMenu />
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <!-- D: MO 공지사항 상세 팝업 -->
  <MoNoticeDetailPop v-if="data.popup.isModallVisible" />
</template>
<script setup name="noticeList">
import { onMounted, reactive, watch, computed, onActivated } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import FaqListTab from "@/components/paintpro/custCenter/faqListTab.vue";
import InquiryTab from "@/components/paintpro/custCenter/inquiryTab.vue";
import NoticeTab from "@/components/paintpro/custCenter/noticeTab.vue";
import MoNoticeDetailPop from "@/components/paintpro/custCenter/moNoticeDetailPop.vue";

import { useRoute, useRouter } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const router = useRouter();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
    query: {},
    empIndex: 0,
    zempName: null,
    zphoneNo: null,
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    isModallVisible: false,
  },
  tab1Index: 0,
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (data.page.userLoginInfo?.empList?.length > 0) {
      if (data.page.empIndex != newValue) {
        data.page.empIndex = newValue;
        data.page.zempName = data.page.userLoginInfo.empList[newValue]?.zempName;
        data.page.zphoneNo = data.page.userLoginInfo.empList[newValue]?.zphoneNo;
      }
    }
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});
onActivated(() => {});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  data.tab1Index = 2;
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: noticeList.pageInitData] `);
    return false;
  }

  const { userLoginInfo } = res.data;
  data.page.userLoginInfo = userLoginInfo;
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;

  if (store.useEventBusStore().salesPersonIndex == data.page.empIndex) {
    data.page.zempName =
      data.page.userLoginInfo.empList[data.page.empIndex]?.zempName;
    data.page.zphoneNo =
      data.page.userLoginInfo.empList[data.page.empIndex]?.zphoneNo;
  } else {
    data.page.zempName =
      data.page.userLoginInfo.empList[
        store.useEventBusStore().salesPersonIndex
      ]?.zempName;
    data.page.zphoneNo =
      data.page.userLoginInfo.empList[
        store.useEventBusStore().salesPersonIndex
      ]?.zphoneNo;
  }
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "고객센터", path: "/paintpro/custCenterList" },
    { name: "공지사항", path: "" },
  ];
  return list;
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "tab1Click") {
    data.tab1Index = parms.tab1Index;
    if (parms.tab1Index === 0) {
      router.push({
        path: "/paintpro/custCenterList",
      });
    } else if (parms.tab1Index === 1) {
      router.push({
        path: "/paintpro/custCenterList/reqList",
      });
    } else if (parms.tab1Index === 2) {
      router.push({
        path: "/paintpro/custCenterList/noticeList",
      });
    }
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
